import AttestationsApi from '@api/AttestationsApi';

export default {
  UPDATE_ATTESTATIONS (context, options = {}) {
    context.commit('SET_ATTESTATIONS_LOADING', true);
    return new AttestationsApi().updateAttestations(options)
    .then(response => {
      // TODO:  uh.  something?
      //console.log(response);
    })
    .catch(error => {
      console.log(error)
    })
    .finally(() => {
      context.commit('SET_ATTESTATIONS_LOADING', true);
    });
  },
  CANCEL_ATTESTATION_REQUEST(context, payload) {
    context.commit('SET_ATTESTATIONS_LOADING', true);
    return new AttestationsApi().cancelAttestationRequest(payload)
    .then(response => {
      console.log(response);
    })
    .catch(error => {
      console.log(error);  
    })
    .finally(() => {
      context.commit('SET_ATTESTATIONS_LOADING', false);
    });
  },
  CLIENT_APPROVE_ATTESTATIONS (context, payload) {
    context.commit('SET_ATTESTATIONS_LOADING', true);
    return new AttestationsApi().clientApproveAttestations(payload)
    .then(response => {
       console.log(response);
    })
    .catch(error => {
      console.log(error);
    })
    .finally(() => {
      context.commit('SET_ATTESTATIONS_LOADING', false);
    })
  },
  GET_ATTESTATION_HISTORY(context, opts) {
    context.commit('SET_ATTESTATIONS_LOADING', true);
    return new AttestationsApi().getHistoricalAttestations(opts)
    .then(response => {
      context.commit('SET_ATTESTATION_HISTORY', response);
    })
    .catch((err) => {
      console.error(err);
    })
    .finally(() => {
      context.commit('SET_ATTESTATIONS_LOADING', false);
    });
  },
  GET_USER_ATTESTATIONS_BY_PARENT_GROUP (context, opts) {
    let parentGroupCk = opts.parentGroupCk;
    context.commit('SET_ATTESTATIONS_LOADING', true);
    return new AttestationsApi().getUserAttestationsByParentGroup(parentGroupCk)
    .then(response => {
      context.commit('SET_ATTESTATION_DETAIL', response);
      context.commit('SET_ATTESTATIONS_LOADING', false);
    })
    .catch(err => {
      context.commit('SET_ATTESTATIONS_LOADING', false);
    })
  },
  GET_USER_ATTESTATIONS (context, opts) {
    context.commit('SET_ATTESTATIONS_LOADING', true);
    return new AttestationsApi().getUserAttestations(opts)
    .then(response => {
      context.commit('SET_ATTESTATIONS', response);
      context.commit('SET_ATTESTATIONS_LOADING', false);
    })
    .catch(err => {
      context.commit('SET_ATTESTATIONS_LOADING', false);
    })
  },
  GET_CLIENT_APPROVAL_LIST (context, opts) {
    context.commit('SET_ATTESTATIONS_LOADING', true)
    new AttestationsApi({
      simulateExample: 'Get Client Approval List'
    })
      .getClientApprovalList(opts)
      .then(response => {
        context.commit('SET_ATTESTATIONS', response);
        context.commit('SET_ATTESTATIONS_LOADING', false);
      })
      .catch(_ => {
        context.commit('SET_ATTESTATIONS_LOADING', false);
      })
  },

  GET_CLIENT_APPROVAL_DETAIL (context, {parentGroupCk, userId}) {
    context.commit('SET_ATTESTATIONS_LOADING', true)
    new AttestationsApi()
      .getClientApprovalDetail(parentGroupCk, userId)
      .then(response => {
        context.commit('SET_ATTESTATION_DETAIL', response);
        context.commit('SET_ATTESTATIONS_LOADING', false);
      })
      .catch(_ => {
        context.commit('SET_ATTESTATIONS_LOADING', false);
      })
  },

  GET_INTERNAL_APPROVAL_LIST (context, opts) {
    context.commit('SET_ATTESTATIONS_LOADING', true);
    return new AttestationsApi().getInternalApprovals(opts)
    .then(response => {
      context.commit('SET_ATTESTATIONS', response);
      context.commit('SET_ATTESTATIONS_LOADING', false);
    })
    .catch(error => {
      context.commit('SET_ATTESTATIONS_LOADING', false);
    })
  },
  GET_INTERNAL_DETAIL (context, {parentGroupCk, clientId, originatingUserId }) {
    context.commit('SET_ATTESTATIONS_LOADING', true);
    return new AttestationsApi().getInternalDetails(parentGroupCk, clientId, originatingUserId)
    .then(response => {
      context.commit('SET_ATTESTATION_DETAIL', response);
      context.commit('SET_ATTESTATIONS_LOADING', false);
    })
    .catch(error => {
      context.commit('SET_ATTESTATIONS_LOADING', false);
    })
  },
  FETCH_ATTESTATION_UNSEEN_COUNT(context) {
    return new AttestationsApi().getUnseenCount()
    .then((result) => {
      context.commit('SET_ATTESTATION_CONFIRMATIONS_PENDING', result.attestationConfirmationsPending || 0);
      context.commit('SET_ATTESTATION_REQUESTS_PENDING', result.attestationRequestPending || 0);
    })
    .catch((err) => {
      if(err.message.match(/^(401|403|500).*$/)) {
       context.commit('CLEAR_ATTESTATION_POLLING_HANDLE');
      }
    });
  },
  CYCLE_ATTESTATION_COUNT({dispatch, commit, getters, rootGetters }) {
    let poll = () => {
      dispatch('FETCH_ATTESTATION_UNSEEN_COUNT');
    }
    let ONE_MINUTE = 60 * 1000;  // ms
    let handle = setInterval(poll, ONE_MINUTE);
    commit('SET_ATTESTATION_POLLING_HANDLE', handle);
  }
}
